module.exports = __webpack_public_path__ + "img/active_08.e4f9226c.jpg";